import { ReactComponent as Info } from '../../assets/images/info-circle.svg';
import { Box, Stack, Typography, Link } from '@mui/material';
import { RedTheme } from 'common/global';
import { TapGlobalMessages } from 'TAP/global';

export const CurriCulumAdditionDisclaimer = () => {
  const redtheme = RedTheme;

  const disclaimerContentStyle = {
    borderRadius: '8px',
    bgcolor: redtheme.palette.info.light,
    padding: '8px',
  };

  const infoIconStyle = {
    width: '24px',
    height: '24px',
    color: redtheme.palette.info.main,
  };

  const disclaimerTypographyStyle = {
    fontSize: '10px',
    fontWeight: 500,
    ontFamily: '"JohnsonText-Bold"',
    lineHeight: '12px',
  };

  return (
    <Box sx={disclaimerContentStyle}>
      <Stack direction='row' spacing={0.65} sx={{ alignItems: 'center' }}>
        <Info sx={infoIconStyle} />
        <Box>
          <Typography sx={disclaimerTypographyStyle}>
            {TapGlobalMessages.userGroupProfile.disclaimer}
            <Link href='mailto:ra-jacnl-lprdadmins@its.jnj.com'>{`Learning@Pharma R&D Admin`}</Link>
            {` for questions or support. `}
            {TapGlobalMessages.userGroupProfile.disclaimerNote()}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
